<template>
  <elements-one-page v-if="site == 'elementsone'"></elements-one-page>
  <el-page v-else></el-page>
</template>

<script>
import { global } from '../mixins/global';

export default {
  name: 'main-page',
  mixins: [global],
  components: {
    ElPage: () => import('./ElPage.vue'),
    ElementsOnePage: () => import('./ElementsOnePage.vue')
  }
};
</script>
